import { HttpMethod } from '@aibees/shared/definition';
import { baseQueryClient } from '@aibees/shared/http/base-query-client';
import { useBaseMutation } from '@aibees/shared/http/hooks';
import {
  NotificationMessageChannel,
  NotificationMessageGroup,
  NotificationStatus,
} from '../types';
import { NOTIFICATION_API_PREFIX } from './constants';
import { useBrowseNotificationsApi } from './use-browse-notifications-api';
import { useBrowseNotificationsCountApi } from './use-browse-notifications-count-api';

type UpdateNotificationStatusesRequest = {
  groups: NotificationMessageGroup[];
  channels: NotificationMessageChannel[];
};

export function useUpdateNotificationStatusesMutationApi() {
  return useBaseMutation<UpdateNotificationStatusesRequest, any>(
    {
      url: NOTIFICATION_API_PREFIX,
      method: HttpMethod.put,
      params: {
        action: 'deliver-all',
      },
    },
    {
      onSettled() {
        baseQueryClient.invalidateQueries([
          useBrowseNotificationsCountApi.name,
          NotificationStatus.ALL,
        ]);
        baseQueryClient.invalidateQueries([
          useBrowseNotificationsApi.name,
          0,
          { size: 25, statuses: NotificationStatus.ALL },
        ]);
      },
    }
  );
}
